// this is an autogenerated file from App/Account/Content/Tasks/mutation-update-board-status.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Tasks(
  $board_id: uuid!
  $status: tasks_statuses_enum!
) {
  update_tasks_boards_by_pk(
    pk_columns: { id: $board_id }
    _set: { status: $status }
  ) {
    id
  }
}

`